module.exports = __webpack_public_path__ + "static/media/verification_code.a5789ea1.png";